import { useQuery } from '@tanstack/react-query'
import { reactQueryRequest } from 'api/makeQuery'
import type { Ticket } from 'components/tickets/types'
import { useFlags } from 'launchdarkly-react-client-sdk'

const useVisitTickets = (visitId?: string) => {
  const flags = useFlags()
  const showPhase4Tickets = flags?.tcZendeskTicketsPhase4

  const {
    data: tickets,
    isLoading,
    isError,
  } = useQuery<Ticket[]>({
    queryKey: ['visitTickets', visitId, showPhase4Tickets],
    queryFn: () =>
      reactQueryRequest('getVisitTickets', {
        visitId,
        showPhase4Tickets,
      }).then((response) => response),
    enabled: !!visitId,
  })

  return { tickets, isLoading, isError }
}

export default useVisitTickets
